import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NotificationModel } from '../models/notification.model';
import { CaptionPipe } from '../pipes/caption.pipe';
import { ModalMakerService } from './modal-maker.service';
import { ToastMachineService } from './toast-machine.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  notifications: NotificationModel[] = [];

  constructor(
    private http: HttpClient,
    private toaster: ToastMachineService,
    private translate: CaptionPipe,
    private modalServ: ModalMakerService,
  ) { }

  getNotifications(hotelId: number, check_archive_time?: boolean): Promise<NotificationModel[]> {
    return new Promise((resolve, reject) => {
      let url = environment.apiURL + '/survey_headers/' + hotelId + `?${new Date().getTime()}`;
      if (check_archive_time) {
        url += '&check_archive_time=true';
      }
  
      this.http.get(url).subscribe(
        {
          next: async (resp: NotificationModel[]) => {
            const NOTI: number[] = JSON.parse(localStorage.getItem('readedNoti')) || [];
  
            resp = resp.filter(x => (this.translate.transform(x.title) || this.translate.transform(x.description)) && x.status);
  
            this.notifications = resp;
  
            for (const NOTIFICATION of this.notifications) {
              if (!sessionStorage.getItem(`popupNotificationsCheck`)) {
                if (NOTIFICATION.is_pop_up && !NOTI.includes(NOTIFICATION.id)) {
                  await this.modalServ.openNotification(NOTIFICATION);
                }
              }
            }
  
            NOTI.forEach(x => {
              this.notifications = this.notifications.filter(y => y.id !== x);
            });
  
            resolve(resp);
          },
          error: err => {
            const error = err.error && err.error.message ? err.error.message : err.message;
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          }
        });
    });
    
  }
}
